import useQueryParams from "@shared/hooks/useQueryParams";
import { FC, useEffect, useState } from "react";
import Pagination from "../Pagination";

interface Props {
  metaPagination: {
    page: string;
    limit: string;
    total: number;
    load_more: boolean;
  };
  startLoading: () => void;
}

const FestivalCardsPagination: FC<Props> = ({
  metaPagination,
  startLoading,
}) => {
  const { removeParamByKey, setParam, getParam } = useQueryParams();

  const [currentPage, setCurrentPage] = useState<number>(
    Number(getParam("page")) || 1
  );
  const handleChangePage = (page: number) => {
    removeParamByKey("page");
    setParam({ key: "page", value: String(page), redirect: true });
  };

  useEffect(() => {
    setCurrentPage(Number(metaPagination.page));
  }, [metaPagination]);

  const totalPage = Number(metaPagination.total);
  const limit = Number(metaPagination.limit);
  const totalPages = Math.ceil(totalPage / limit);

  return (
    <>
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={(page) => {
          handleChangePage(page);
          startLoading();
        }}
        pageItemsToShow={5}
      />
    </>
  );
};

export default FestivalCardsPagination;
